<script setup>
import { parseHeziyunData } from '@/utils/heziyunData' // 解析数据


const HeziyunData = ref(parseHeziyunData().global)

console.log(HeziyunData.value)


</script>
<template>
    <!-- banner图 -->
    <div class="Heziyun-banners">
        <div class="Heziyun-defaultWidth">
            <div class="Heziyun-banner-title">
                <span v-intersect="{ class: 'bottom-top', delay: 0 }">{{ $t('cps.bannerTitle') }}</span>
                <p v-intersect="{ class: 'bottom-top', delay: 200 }">
                    {{ $t('cps.bannerDesc') }}
                </p>
                <div class="Heziyun-buttonArray" v-intersect="{ class: 'bottom-top', delay: 300 }">
                    <a href="/home.htm">{{ $t('cps.joinNow') }}</a>
                </div>
            </div>
        </div>
    </div>

    <!-- 推广优势 -->
    <div class="Heziyun-promotionAdvantages Heziyun-padding">
        <div class="Heziyun-defaultWidth">
            <div class="Heziyun-commodity-title">
                <span v-intersect="{ class: 'bottom-top', delay: 0 }">{{ $t('cps.advantagesTitle')
                }}</span>
                <p v-intersect="{ class: 'bottom-top', delay: 100 }">{{ $t('cps.advantagesSubtitle') }}
                </p>
            </div>
            <div class="Heziyun-advantage">
                <div class="Heziyun-itemPower" v-intersect="{ class: 'bottom-top', delay: 200 }">
                    <div class="Heziyun-titles">
                        <span>35%</span>
                        <div class="Heziyun-main">{{ $t('cps.commissionTitle') }}</div>
                    </div>
                    <p>{{ $t('cps.commissionDesc') }}</p>
                    <div class="Heziyun-iconCluster">
                        <img src="@/static/img/cpsExtension/iconCluster1.svg" alt="">
                        <img src="@/static/img/cpsExtension/iconCluster2.svg" alt="">
                        <img src="@/static/img/cpsExtension/iconCluster3.svg" alt="">
                    </div>
                </div>
                <div class="Heziyun-itemPower" v-intersect="{ class: 'bottom-top', delay: 300 }">
                    <div class="Heziyun-majorHeading">
                        <img src="@/static/img/cpsExtension/majorHeading1.png" alt="">
                        <span>{{ $t('cps.conversionTitle') }}</span>
                    </div>
                    <p>{{ $t('cps.conversionDesc') }}</p>
                </div>
                <div class="Heziyun-itemPower" v-intersect="{ class: 'bottom-top', delay: 400 }">
                    <div class="Heziyun-majorHeading">
                        <img src="@/static/img/cpsExtension/majorHeading2.png" alt="">
                        <span>{{ $t('cps.coverageTitle') }}</span>
                    </div>
                    <p>{{ $t('cps.coverageDesc') }}</p>
                </div>
                <div class="Heziyun-itemPower" v-intersect="{ class: 'bottom-top', delay: 500 }">
                    <div class="Heziyun-majorHeading">
                        <img src="@/static/img/cpsExtension/majorHeading3.png" alt="">
                        <span>{{ $t('cps.settlementTitle') }}</span>
                    </div>
                    <p>{{ $t('cps.settlementDesc') }}</p>
                </div>
            </div>
        </div>
    </div>

    <!-- 加入云推官 -->
    <div class="Heziyun-cloudPushOfficial Heziyun-padding">
        <div class="Heziyun-defaultWidth">
            <div class="Heziyun-commodity-title">
                <span v-intersect="{ class: 'bottom-top', delay: 0 }">{{ $t('cps.joinTitle') }}</span>
                <p v-intersect="{ class: 'bottom-top', delay: 100 }">{{ $t('cps.joinSubtitle') }}</p>
            </div>
            <div class="Heziyun-yunGuan">
                <div class="Heziyun-itemExtension" v-intersect="{ class: 'bottom-top', delay: 200 }">
                    <div class="Heziyun-ball">
                        <img src="@/static/img/cpsExtension/itemball1.webp" alt="">
                    </div>
                    <span><i>01</i>{{ $t('cps.step1Title') }}</span>
                    <div class="Heziyun-label">{{ $t('cps.step1Time') }}</div>
                    <p>{{ $t('cps.step1Desc') }}</p>
                </div>
                <div class="Heziyun-itemExtension" v-intersect="{ class: 'bottom-top', delay: 300 }">
                    <div class="Heziyun-ball">
                        <img src="@/static/img/cpsExtension/itemball2.webp" alt="">
                    </div>
                    <span><i>02</i>{{ $t('cps.step2Title') }}</span>
                    <div class="Heziyun-label">{{ $t('cps.step2Time') }}</div>
                    <p>{{ $t('cps.step2Desc') }}</p>
                </div>
                <div class="Heziyun-itemExtension" v-intersect="{ class: 'bottom-top', delay: 400 }">
                    <div class="Heziyun-ball">
                        <img src="@/static/img/cpsExtension/itemball3.webp" alt="">
                    </div>
                    <span><i>03</i>{{ $t('cps.step3Title') }}</span>
                    <div class="Heziyun-label">{{ $t('cps.step3Time') }}</div>
                    <p>{{ $t('cps.step3Desc') }}</p>
                </div>
                <div class="Heziyun-itemExtension" v-intersect="{ class: 'bottom-top', delay: 500 }">
                    <div class="Heziyun-ball">
                        <img src="@/static/img/cpsExtension/itemball4.webp" alt="">
                    </div>
                    <span><i>04</i>{{ $t('cps.step4Title') }}</span>
                    <div class="Heziyun-label">{{ $t('cps.step4Time') }}</div>
                    <p>{{ $t('cps.step4Desc') }}</p>
                </div>
            </div>
        </div>
    </div>

    <!-- 推广方式 -->
    <div class="Heziyun-extensionWay Heziyun-padding">
        <div class="Heziyun-defaultWidth">
            <div class="Heziyun-commodity-title">
                <span v-intersect="{ class: 'bottom-top', delay: 0 }">{{ $t('cps.methodsTitle')
                }}</span>
                <p v-intersect="{ class: 'bottom-top', delay: 100 }">{{ $t('cps.methodsSubtitle') }}</p>
            </div>
            <div class="Heziyun-extension">
                <div class="Heziyun-itemPush" v-intersect="{ class: 'bottom-top', delay: 200 }">
                    <img src="@/static/img/cpsExtension/itemPush1.png" alt="">
                    <div class="Heziyun-titles">{{ $t('cps.method1Title') }}</div>
                    <p>{{ $t('cps.method1Desc') }}</p>
                    <div class="Heziyun-location">
                        <p>
                            <img src="@/static/img/cpsExtension/location.svg" alt="">
                            {{ $t('cps.method1Feature1') }}
                        </p>
                        <p>
                            <img src="@/static/img/cpsExtension/location.svg" alt="">
                            {{ $t('cps.method1Feature2') }}
                        </p>
                        <p>
                            <img src="@/static/img/cpsExtension/location.svg" alt="">
                            {{ $t('cps.method1Feature3') }}
                        </p>
                    </div>
                </div>
                <div class="Heziyun-itemPush" v-intersect="{ class: 'bottom-top', delay: 350 }">
                    <img src="@/static/img/cpsExtension/itemPush2.png" alt="">
                    <div class="Heziyun-titles">{{ $t('cps.method2Title') }}</div>
                    <p>{{ $t('cps.method2Desc') }}</p>
                    <div class="Heziyun-location">
                        <p>
                            <img src="@/static/img/cpsExtension/location.svg" alt="">
                            {{ $t('cps.method2Feature1') }}
                        </p>
                        <p>
                            <img src="@/static/img/cpsExtension/location.svg" alt="">
                            {{ $t('cps.method2Feature2') }}
                        </p>
                        <p>
                            <img src="@/static/img/cpsExtension/location.svg" alt="">
                            {{ $t('cps.method2Feature3') }}
                        </p>
                    </div>
                </div>
                <div class="Heziyun-itemPush" v-intersect="{ class: 'bottom-top', delay: 450 }">
                    <img src="@/static/img/cpsExtension/itemPush3.png" alt="">
                    <div class="Heziyun-titles">{{ $t('cps.method3Title') }}</div>
                    <p>{{ $t('cps.method3Desc') }}</p>
                    <div class="Heziyun-location">
                        <p>
                            <img src="@/static/img/cpsExtension/location.svg" alt="">
                            {{ $t('cps.method3Feature1') }}
                        </p>
                        <p>
                            <img src="@/static/img/cpsExtension/location.svg" alt="">
                            {{ $t('cps.method3Feature2') }}
                        </p>
                        <p>
                            <img src="@/static/img/cpsExtension/location.svg" alt="">
                            {{ $t('cps.method3Feature3') }}
                        </p>
                    </div>
                </div>
            </div>
            <a href="/home.htm" v-intersect="{ class: 'bottom-top', delay: 500 }">{{
                $t('cps.startPromotion') }}</a>
        </div>
    </div>

    <!-- 代销优势 -->
    <div class="Heziyun-distributorAdvantage">
        <div class="Heziyun-padding">
            <div class="Heziyun-defaultWidth">
                <div class="Heziyun-commodity-title">
                    <span v-intersect="{ class: 'bottom-top', delay: 0 }">{{ $t('cps.distributorTitle')
                    }}</span>
                    <p v-intersect="{ class: 'bottom-top', delay: 100 }">{{
                        $t('cps.distributorSubtitle') }}</p>
                </div>
                <div class="Heziyun-melt">
                    <table v-intersect="{ class: 'bottom-top', delay: 100 }">
                        <colgroup>
                            <col style="width: 20%;">
                            <col style="width: 40%;">
                            <col style="width: 40%;">
                        </colgroup>
                        <thead>
                            <tr>
                                <th>{{ $t('cps.comparisonItem') }}</th>
                                <th>{{ $t('cps.otherVendors') }}</th>
                                <th
                                    style="background: #2c6bff;border-radius: 0 4px 0 0;color: #fff;border-top: 2px solid #2c6bff;">
                                    <img src="@/static/img/cpsExtension/logo-private.svg" alt="">{{
                                        HeziyunData?.webname }}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{{ $t('cps.commissionAmount') }}</td>
                                <td>{{ $t('cps.otherCommissionAmount') }}</td>
                                <td>{{ $t('cps.ourCommissionAmount') }}</td>
                            </tr>
                            <tr>
                                <td>{{ $t('cps.settlementCycle') }}</td>
                                <td>{{ $t('cps.otherSettlementCycle') }}</td>
                                <td>{{ $t('cps.ourSettlementCycle') }}</td>
                            </tr>
                            <tr>
                                <td>{{ $t('cps.promotionScope') }}</td>
                                <td>{{ $t('cps.otherPromotionScope') }}</td>
                                <td>{{ $t('cps.ourPromotionScope') }}</td>
                            </tr>
                            <tr>
                                <td>{{ $t('cps.orderValidity') }}</td>
                                <td>{{ $t('cps.otherOrderValidity') }}</td>
                                <td>{{ $t('cps.ourOrderValidity') }}</td>
                            </tr>
                            <tr>
                                <td>{{ $t('cps.technicalSupport') }}</td>
                                <td>{{ $t('cps.otherTechnicalSupport') }}</td>
                                <td>{{ $t('cps.ourTechnicalSupport') }}</td>
                            </tr>
                            <tr>
                                <td>{{ $t('cps.commissionTiers') }}</td>
                                <td>{{ $t('cps.otherCommissionTiers') }}</td>
                                <td>{{ $t('cps.ourCommissionTiers') }}</td>
                            </tr>
                            <tr>
                                <td>{{ $t('cps.settlementMethods') }}</td>
                                <td>{{ $t('cps.otherSettlementMethods') }}</td>
                                <td>{{ $t('cps.ourSettlementMethods') }}</td>
                            </tr>
                            <tr>
                                <td>{{ $t('cps.promotionMaterials') }}</td>
                                <td>{{ $t('cps.otherPromotionMaterials') }}</td>
                                <td>{{ $t('cps.ourPromotionMaterials') }}</td>
                            </tr>
                            <tr>
                                <td>{{ $t('cps.dataReports') }}</td>
                                <td>{{ $t('cps.otherDataReports') }}</td>
                                <td>{{ $t('cps.ourDataReports') }}</td>
                            </tr>
                            <tr>
                                <td>{{ $t('cps.customerOwnership') }}</td>
                                <td>{{ $t('cps.otherCustomerOwnership') }}</td>
                                <td>{{ $t('cps.ourCustomerOwnership') }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>

    <!-- 代销规则 -->
    <div class="Heziyun-distributorRules Heziyun-padding">
        <div class="Heziyun-defaultWidth">
            <div class="Heziyun-commodity-title">
                <span v-intersect="{ class: 'bottom-top', delay: 0 }">{{ $t('cps.rulesTitle') }}</span>
                <p v-intersect="{ class: 'bottom-top', delay: 100 }">{{ $t('cps.rulesSubtitle') }}</p>
            </div>
            <div class="Heziyun-consignmentSales">
                <div class="Heziyun-itemRule" v-intersect="{ class: 'bottom-top', delay: 200 }">
                    <div class="Heziyun-titlesIcon">
                        <img src="@/static/img/cpsExtension/content5-icon1.png" alt="">
                        <span>{{ $t('cps.commissionRulesTitle') }}</span>
                    </div>
                    <p>{{ $t('cps.firstSaleCommission') }}</p>
                    <p>{{ $t('cps.renewalCommission') }}</p>
                </div>
                <div class="Heziyun-itemRule" v-intersect="{ class: 'bottom-top', delay: 300 }">
                    <div class="Heziyun-titlesIcon">
                        <img src="@/static/img/cpsExtension/content5-icon1.png" alt="">
                        <span>{{ $t('cps.qualificationTitle') }}</span>
                    </div>
                    <p>{{ $t('cps.qualificationDesc') }}</p>
                </div>
                <div class="Heziyun-itemRule" v-intersect="{ class: 'bottom-top', delay: 400 }">
                    <div class="Heziyun-titlesIcon">
                        <img src="@/static/img/cpsExtension/content5-icon1.png" alt="">
                        <span>{{ $t('cps.validSalesTitle') }}</span>
                    </div>
                    <p><i class="Heziyun-primary">1</i>{{ $t('cps.validSalesRule1') }}</p>
                    <p><i class="Heziyun-primary">2</i>{{ $t('cps.validSalesRule2') }}</p>
                    <p><i class="Heziyun-primary">3</i>{{ $t('cps.validSalesRule3') }}</p>
                    <p><i class="Heziyun-primary">4</i>{{ $t('cps.validSalesRule4') }}</p>
                    <p><i class="Heziyun-primary">5</i>{{ $t('cps.validSalesRule5') }}</p>
                </div>
                <div class="Heziyun-itemRule" v-intersect="{ class: 'bottom-top', delay: 500 }">
                    <div class="Heziyun-titlesIcon">
                        <img src="@/static/img/cpsExtension/content5-icon1.png" alt="">
                        <span>{{ $t('cps.settlementTitle') }}</span>
                    </div>
                    <p><i class="Heziyun-primary">1</i>{{ $t('cps.settlementRule1') }}</p>
                    <p><i class="Heziyun-primary">2</i>{{ $t('cps.settlementRule2') }}</p>
                </div>
                <div class="Heziyun-itemRule" v-intersect="{ class: 'bottom-top', delay: 600 }">
                    <div class="Heziyun-titlesIcon">
                        <img src="@/static/img/cpsExtension/content5-icon1.png" alt="">
                        <span>{{ $t('cps.prohibitedTitle') }}</span>
                    </div>
                    <p>{{ $t('cps.prohibitedDesc') }}</p>
                </div>
            </div>
        </div>
    </div>

</template>

<style>
@import "@/static/css/import";
@import "@/static/css/color.css";
@import "@/static/font/font.css";
</style>

<style lang="less" scoped>
@font-face {
    font-family: "italices";
    font-weight: 400;
    src: url("@/static/font/file/italics.woff2") format("woff2");
    font-display: swap;
}

// banner图
.Heziyun-banners {
    background: url('@/static/img/cpsExtension/banner.webp') no-repeat right;
    background-size: cover;
    position: relative;
    mask-image: linear-gradient(to bottom, black 0%, black 75%, transparent 100%);

    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.05);
        z-index: 1;
    }

    .Heziyun-defaultWidth {
        position: relative;
        z-index: 2;
        height: 100%;



        .Heziyun-banner-title {
            align-items: center;

            span {
                font-family: "italices";
                background: linear-gradient(45deg, #FF6B00 0%, #FF8C00 25%, #FFA500 50%, #ffe9b2 75%, #ffffff 100%);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
                background-clip: text;
            }

            p {
                text-align: center;
                color: #333;
            }
        }
    }

}

// 推广优势 
.Heziyun-promotionAdvantages {

    .Heziyun-defaultWidth {
        .Heziyun-advantage {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 1.5rem;

            .Heziyun-itemPower:nth-of-type(1) {
                background: linear-gradient(0deg, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0)), linear-gradient(135deg, #6397f1 -6%, #3a51ed 99%);
                padding: 1.5rem;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                border: none;

                .Heziyun-titles {
                    display: flex;
                    align-items: center;
                    gap: 1rem;
                    margin-bottom: 0.5rem;

                    span {
                        color: #fff;
                        font-weight: bold;
                        font-size: 2rem;
                    }

                    .Heziyun-main {
                        color: #fff;
                        font-size: 1rem;
                    }
                }

                p {
                    color: #fff;
                    margin-bottom: 0.5rem;
                }

                .Heziyun-iconCluster {
                    display: flex;
                    align-items: center;
                    gap: 0.5rem;

                    img {
                        width: 1rem;
                        height: 1rem;
                    }
                }
            }

            .Heziyun-itemPower {
                padding: 1.5rem 2rem;
                border-radius: 0.5rem;
                display: flex;
                flex-direction: column;
                background-image: linear-gradient(0deg, #ffffff 0%, #f3f5f8 100%);
                box-shadow: 8px 8px 20px 0 rgba(55, 99, 170, 0.1);
                border: 2px solid #fff;
                box-shadow: 0 0 8px rgba(0, 0, 0, 0.08);

                .Heziyun-majorHeading {
                    display: flex;
                    align-items: center;
                    gap: 1rem;
                    margin-bottom: 0.5rem;

                    img {
                        width: 3rem;
                        height: 3rem;
                        object-fit: contain;
                    }

                    span {
                        color: #000000;
                        font-weight: bold;
                        font-size: 1.1rem;
                    }
                }

                p {
                    color: #4B5563;
                    line-height: 1.7;
                }
            }
        }
    }
}

// 加入云推官
.Heziyun-cloudPushOfficial {
    background-color: rgb(250, 250, 252);

    .Heziyun-defaultWidth {
        .Heziyun-yunGuan {
            display: grid;
            grid-template-columns: repeat(4, 1fr);
            align-items: center;
            gap: 5rem;

            .Heziyun-itemExtension {
                display: flex;
                flex-direction: column;
                align-items: center;
                gap: 0.5rem;
                position: relative;

                .Heziyun-ball {
                    border-radius: 50%;
                    -webkit-border-radius: 50%;
                    -moz-border-radius: 50%;
                    -ms-border-radius: 50%;
                    -o-border-radius: 50%;
                    width: 6.5rem;
                    height: 6.5rem;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    gap: 0.3rem;
                    position: relative;
                    background-color: rgb(239, 243, 255);

                    img {
                        width: 3.5rem;
                        height: 3.5rem;
                        object-fit: contain;
                    }

                }

                span {
                    color: #333;
                    font-size: 1.1rem;
                    margin-top: 1rem;
                    display: flex;
                    align-items: center;
                    font-weight: bold;
                    gap: 0.4rem;

                    i {
                        font-style: normal;
                        color: rgb(132, 134, 139);
                        font-family: 'italices';
                    }
                }

                .Heziyun-label {
                    background-color: rgb(237, 245, 255);
                    color: rgb(58, 127, 253);
                    padding: 3px 10px;
                    border-radius: 100px;
                    font-weight: 700;
                    font-size: 12px;
                }

                p {
                    color: rgb(172, 171, 183);
                }
            }

            .Heziyun-itemExtension:not(:last-child)::after {
                content: "";
                position: absolute;
                background: url('@/static/img/cpsExtension/arrow.png') no-repeat center;
                background-size: contain;
                width: 3rem;
                height: 3rem;
                top: 2.5rem;
                left: 18rem;
                transform: rotate(270deg);
                animation: changes 2s ease infinite;
                -webkit-animation: changes 2s ease infinite;
            }
        }
    }
}

// 推广方式
.Heziyun-extensionWay {
    background-color: rgb(249, 250, 251);

    .Heziyun-defaultWidth {
        display: flex;
        flex-direction: column;

        .Heziyun-extension {
            display: grid;
            grid-template-columns: repeat(3, 1fr);

            .Heziyun-itemPush {
                display: flex;
                flex-direction: column;
                gap: 1rem;
                background: #FFFFFF;
                border: 0.06rem solid #F3F4F6;
                padding: 2rem;
                transition: all 0.4s ease;
                -webkit-transition: all 0.4s ease;
                -moz-transition: all 0.4s ease;
                -ms-transition: all 0.4s ease;
                -o-transition: all 0.4s ease;

                &:hover {
                    box-shadow: 0 10px 20px rgba(0, 102, 255, 0.1);
                    transition: all 0.4s ease;
                    -webkit-transition: all 0.4s ease;
                    -moz-transition: all 0.4s ease;
                    -ms-transition: all 0.4s ease;
                    -o-transition: all 0.4s ease;
                }

                img {
                    width: 4rem;
                    height: 4rem;
                    object-fit: contain;
                }

                .Heziyun-titles {
                    color: #000000;
                    font-weight: bold;
                    font-size: 1.1rem;
                }

                p {
                    color: #4B5563;
                    line-height: 1.5rem;
                    font-size: 0.8rem;
                }

                .Heziyun-location {
                    display: flex;
                    flex-direction: column;
                    gap: 0.2rem;

                    p {
                        display: flex;
                        align-items: center;
                        gap: 0.3rem;

                        img {
                            width: 0.8rem;
                            height: 0.8rem;
                        }
                    }
                }
            }
        }

        a {
            background-color: rgb(0, 102, 255);
            color: #fff;
            padding: 0.7rem 1.6rem;
            margin: 2rem auto 0 auto;

            &:hover {
                background-color: rgb(54, 133, 252);
            }
        }
    }
}

// 代销优势
.Heziyun-distributorAdvantage {
    position: relative;

    .Heziyun-defaultWidth {

        .Heziyun-melt {
            table {
                width: 100%;
                border-collapse: collapse;
                text-align: center;

                th,
                td {
                    border: 1px solid #E5E7EB;
                    padding: 1rem;
                }

                th {
                    background-color: #F3F4F6;
                    color: #111827;
                    font-weight: bold;
                    font-size: 1rem;

                    img {
                        width: 1.3rem;
                        height: 1.3rem;
                        object-fit: contain;
                        margin-right: 5px;
                    }
                }

                td {
                    color: #6B7280;
                }

                /* 为所有行的第三列添加边框 */
                tr td:nth-child(3),
                tr th:nth-child(3) {
                    border-left: 2px solid #2c6bff;
                    border-right: 2px solid #2c6bff;
                }

                // 最后一个tr中的td添加边框
                tr:last-child td:last-child {
                    border-bottom: 2px solid #2c6bff;
                }

                // 每偶数tr中的td添加背景
                tr:nth-child(even) td {
                    background-color: rgb(0 0 0 / 2%);
                }
            }
        }
    }
}

// 代销规则
.Heziyun-distributorRules {
    background: url('@/static/img/cpsExtension/content4-bg.webp') no-repeat center;
    background-size: cover;

    .Heziyun-defaultWidth {
        .Heziyun-commodity-title {
            span {
                color: #fff;
            }

            p {
                color: #eee;
            }
        }

        .Heziyun-consignmentSales {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 1rem;

            .Heziyun-itemRule {
                display: flex;
                flex-direction: column;
                gap: 0.5rem;

                .Heziyun-titlesIcon {
                    display: flex;
                    align-items: center;
                    gap: 0.5rem;

                    img {
                        width: 2rem;
                        height: 2rem;
                        object-fit: contain;
                    }

                    span {
                        color: #fff;
                        font-weight: bold;
                        font-size: 1.2rem;
                    }
                }

                p {
                    color: #eee;
                    display: flex;
                    gap: 0.4rem;
                    line-height: 1.7;
                    margin-left: 20px;

                    .Heziyun-primary {
                        background: #3B82F6;
                        color: #fff;
                        border-radius: 5rem;
                        width: 1rem;
                        height: 1rem;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        font-size: 12px;
                        margin-top: 3px;
                        flex-shrink: 0;
                    }
                }

                i {
                    color: #ffd100;
                    font-style: normal;
                }
            }
        }
    }
}

@media (max-width: 768px) {

    // banner图
    .Heziyun-banners {
        background: url('@/static/img/cpsExtension/banner.webp') no-repeat right;
        background-size: cover;
        height: 110vw;

        .Heziyun-banner-title {
            span {
                text-align: center;
            }

            p {
                width: 85%;
            }
        }
    }

    // 推广优势 
    .Heziyun-promotionAdvantages {

        .Heziyun-defaultWidth {
            .Heziyun-advantage {
                grid-template-columns: repeat(1, 1fr);
                gap: 2vw;

                .Heziyun-itemPower:nth-of-type(1) {
                    padding: 4vw;

                    .Heziyun-titles {
                        gap: 2vw;
                        margin-bottom: 2vw;

                        span {
                            font-size: 6vw;
                        }

                        .Heziyun-main {
                            font-size: 4vw;
                        }
                    }

                    .Heziyun-iconCluster {
                        gap: 2vw;

                        img {
                            width: 5vw;
                            height: 5vw;
                        }
                    }

                    p {

                        margin-bottom: 2vw;
                    }
                }

                .Heziyun-itemPower {
                    padding: 4vw;
                    border-radius: 2vw;
                    -webkit-border-radius: 3vw;
                    -moz-border-radius: 3vw;
                    -ms-border-radius: 3vw;
                    -o-border-radius: 3vw;

                    .Heziyun-majorHeading {
                        gap: 2vw;

                        img {
                            width: 10vw;
                            height: 10vw;
                        }

                        span {
                            font-size: 4vw;
                        }
                    }

                    p {
                        line-height: 6vw;
                        font-size: 3.5vw;
                    }
                }
            }
        }
    }

    // 加入云推官
    .Heziyun-cloudPushOfficial {

        .Heziyun-defaultWidth {
            .Heziyun-yunGuan {
                grid-template-columns: repeat(2, 1fr);
                gap: 5vw;

                .Heziyun-itemExtension {
                    gap: 3vw;

                    .Heziyun-ball {
                        width: 25vw;
                        height: 25vw;
                        gap: 1vw;
                        border: 0.5vw solid #E5E7EB;

                        img {
                            width: 12vw;
                            height: 12vw;
                        }
                    }

                    span {
                        font-size: 4vw;
                        margin-top: 2vw;
                    }

                    p {
                        font-size: 3vw;
                    }
                }
            }
        }
    }

    // 推广方式
    .Heziyun-extensionWay {

        .Heziyun-defaultWidth {

            .Heziyun-extension {
                grid-template-columns: repeat(1, 1fr);

                .Heziyun-itemPush {
                    gap: 3vw;
                    padding: 4vw;

                    img {
                        width: 15vw;
                        height: 15vw;
                    }

                    .Heziyun-titles {
                        font-size: 4.5vw;
                    }

                    p {
                        line-height: 6vw;
                        font-size: 3.5vw;
                    }

                    .Heziyun-location {
                        gap: 2vw;

                        p {
                            gap: 2vw;

                            img {
                                width: 4vw;
                                height: 4vw;
                            }
                        }
                    }
                }
            }

            a {
                padding: 3vw 5vw;
                border-radius: 1vw;
                -webkit-border-radius: 1vw;
                -moz-border-radius: 1vw;
                -ms-border-radius: 1vw;
                -o-border-radius: 1vw;
                margin: 10vw auto 0 auto;
            }
        }
    }

    // 代销优势
    .Heziyun-distributorAdvantage {

        .Heziyun-grid {
            background-size: 3vw 3vw;
        }

        .Heziyun-defaultWidth {

            .Heziyun-melt {

                table {
                    width: 100%;
                    border-collapse: collapse;
                    text-align: center;

                    th,
                    td {
                        border: 1px solid #E5E7EB;
                        padding: 3vw 2vw;
                    }

                    th {
                        background-color: #F3F4F6;
                        color: #111827;
                        font-weight: bold;
                        font-size: 4vw;

                        img {
                            width: 5vw;
                            height: 5vw;
                        }
                    }

                    tr {
                        td {
                            font-size: 3.5vw;
                            line-height: 1.7;
                        }
                    }
                }
            }
        }
    }

    // 代销规则
    .Heziyun-distributorRules {

        .Heziyun-defaultWidth {
            .Heziyun-consignmentSales {
                gap: 4vw;

                .Heziyun-itemRule {
                    gap: 3vw;

                    .Heziyun-titlesIcon {
                        gap: 2vw;
                        margin-bottom: 2vw;

                        img {
                            width: 8vw;
                            height: 8vw;
                        }

                        span {
                            font-size: 4vw;
                        }
                    }

                    p {
                        font-size: 3.5vw;
                        gap: 2vw;
                        line-height: 1.7;
                        margin-left: 0;

                        .Heziyun-primary {
                            width: 5vw;
                            height: 5vw;
                            border-radius: 10vw;
                            -webkit-border-radius: 10vw;
                            -moz-border-radius: 10vw;
                            -ms-border-radius: 10vw;
                            -o-border-radius: 10vw;
                            flex-shrink: 0;
                        }
                    }
                }
            }
        }
    }
}
</style>
